import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/swiper.css'
import './assets/css/common.css'
import dayjs  from 'dayjs'
import 'dayjs/locale/zh-cn' // import locale
import axios from './tools/http'
axios.defaults.baseURL = '/api'
dayjs.locale('zh-cn') // use locale
dayjs.locale('de') 
createApp(App).use(store).use(router).use(Antd).mount('#app')
